<audio #playerEl controls="controls" class="preview-object" [class.hidden]="invalidMedia" controlsList="nodownload noremoteplayback"></audio>

<default-preview *ngIf="invalidMedia"></default-preview>